// extracted by css-extract-rspack-plugin
export default {"spinner":"_eae25baa"};